import React from 'react'
import { Provider } from 'react-redux'

import AppContainer from './app/AppContainer'
import store from './store'

const Root = ({routerParams, authentication}) =>
  <Provider store={store}>
    <AppContainer routerParams={routerParams} authentication={authentication} />
  </Provider>

export default Root



// WEBPACK FOOTER //
// ./src/Root.js